import React from "react";
import styled from "styled-components";
// import { Link } from "react-router-dom";

// Components
import Container from "./components/StyledComponents/Container";
import FwdlookLogo from "./components/FwdlookLogo";
import MediaQuery from "./components/MediaQuery";

const lineHeight = "30px"; // For other items to match the height of logo when in mobile/stacked view
const FooterWrapper = styled.footer`
  position: absolute;
  bottom: 0;
  display: flex;
  width: 100%;
  height: ${props => props.height};
`;
const FooterContent = Container.extend`
  border-top: 1px solid #e7e7e7;
  display: flex;
  padding: 10px;
  font-size: 12px;
  ${MediaQuery.tablet`
    flex-direction: column;
  `};
`;
const Nav = styled.nav`
  display: flex;
  margin-left: auto;
  line-height: ${lineHeight};
  ${MediaQuery.tablet`
    margin: auto;
  `};
`;
const NavItem = styled.div`
  font-weight: 600;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 10px;
`;
const LogoCopywriteWrapper = styled.div`
  display: flex;
  margin-right: auto;
  ${MediaQuery.tablet`
    margin-left: auto;
    margin-right: auto;
  `};
`;
const LogoWrapper = styled.div`
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 10px;
`;
const CopyWrite = styled.div`
  font-weight: 600;
  text-transform: uppercase;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: auto;
`;
// const FwdlookCompany = styled.div`
//   margin: auto;
//   font-weight: 600;
//   line-height: ${lineHeight};
// `;

const Footer = ({ height }) => (
  <FooterWrapper height={height}>
    <FooterContent>
      <LogoCopywriteWrapper>
        <LogoWrapper>
          <FwdlookLogo />
        </LogoWrapper>
        <CopyWrite>&copy; {new Date().getFullYear()} CATCHTRIPS.</CopyWrite>
      </LogoCopywriteWrapper>
      {/* <FwdlookCompany>A FWDLOOK Company.</FwdlookCompany> */}
      <Nav>
        {/* <NavItem> <Link to="/find-my-trip"> Find My Trip </Link> </NavItem> */}
        <NavItem> Email Us: help@catchtrips.com </NavItem>
      </Nav>
    </FooterContent>
  </FooterWrapper>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js